export const HTML_BLOCK = {
  blockType: "HTML",
  blockDesign: "HTMLBlock",
  editFormName: "HTML_FORM_1",
  position: "full",
  html: `<h2>Lorem <i>ipsum</i> dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</h2>`,
};
